export default "__VITE_ASSET__e3a98b7a__"